import { Controller } from "@hotwired/stimulus"

// On a turbo-frame: a click on [data-frame-focus] names the element to focus once the frame
// renders its response ([data-frame-focus-name]), so keyboard focus survives the swap.
export default class extends Controller {
  connect() {
    this.remember = this.remember.bind(this)
    this.restore = this.restore.bind(this)
    this.element.addEventListener("click", this.remember)
    this.element.addEventListener("turbo:frame-render", this.restore)
  }

  disconnect() {
    this.element.removeEventListener("click", this.remember)
    this.element.removeEventListener("turbo:frame-render", this.restore)
  }

  remember(event) {
    this.name = event.target.closest("[data-frame-focus]")?.dataset.frameFocus ?? this.name
  }

  restore() {
    if (!this.name) return
    this.element.querySelector(`[data-frame-focus-name="${CSS.escape(this.name)}"]`)?.focus()
    this.name = null
  }
}
